import { createContext, useContext } from "react";

// Lets a screen (e.g. the weighbridge, where lots change under the operator's
// hands via keyboard/scanner input) opt every field out of the scroll-into-view
// behaviour below, without threading `scrollOnFocus={false}` through every field.
export const ScrollOnFocusContext = createContext(true);

export const useScrollOnFocusDefault = () => useContext(ScrollOnFocusContext);

export const handleSelectAndScrollFocus = (
  event: React.FocusEvent<HTMLInputElement>,
  selectOnFocus: boolean,
  allowScroll: boolean,
) => {
  const input = event.currentTarget;
  if (selectOnFocus) {
    input.select();
  }
  if (allowScroll) {
    const root = input.closest("[data-field-root]");

    const element = root || input;

    // scroll into view doesnt work on selects on iphone without a timeout
    setTimeout(
      () =>
        element.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        }),
      100,
    );
  }
};
